import React from 'react'
import TranslationRowListItem from './translation-row-list-item'

const TranslationRowList = ({
  translations,
  updateTranslation,
  dispatchAddFaqRow
}) => {
  const translationLanguages = Object.keys(translations).map(lang => {
    const translationsLang = translations[lang]

    const translationRows = Object.entries(translationsLang).map(
      translation => {
        return (
          <React.Fragment key={translation[0]}>
            <TranslationRowListItem
              lang={lang}
              info={translation}
              updateTranslation={updateTranslation}
              dispatchAddFaqRow={dispatchAddFaqRow}
              indent={0}
              path={[]}
            />
            <div className='break-sm' />
          </React.Fragment>
        )
      }
    )

    return (
      <div className='row' key={lang}>
        <div className='col-sm-2 bigbold'>{lang}</div>
        <div className='break-lg' />
        <div className='col-sm-12'>{translationRows}</div>
        <div className='break-md' />
      </div>
    )
  })

  return <div className=''>{translationLanguages}</div>
}

export default TranslationRowList
